
{
  "unavailable": "Not available when sending to all locations.",
  "method-options": {
    "ai": "Make it with AI",
    "custom": "Make it yourself"
  },
  "generate": "Generate Email"
}
